import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import TargetRightHandLinksComponent from '@Components/Results/targets/target-right-hand-links.component.jsx';
import TargetDetailsLeftComponent from '@Components/Results/targets/target-details-left.component.jsx';

export default class TargetBasicDetailsComponent extends React.PureComponent {

  render() {
    const { metadata, target, onDetailsToggle, detailsExpanded, trackingAttrs } = this.props;
    const subunits = target.subunits || [];

    return (
      <div className='target-details-container'>
        <div className={`target-details${subunits.length > 1 ? ' target-details--complex' : ''}`}>
          <TargetDetailsLeftComponent
            subunits={subunits}
            detailsExpanded={detailsExpanded}
            onDetailsToggle={onDetailsToggle}
            trackingAttrs={trackingAttrs}
          />
          <TargetRightHandLinksComponent metadata={metadata} target={target}/>
        </div>
      </div>
    );
  }
}

TargetBasicDetailsComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  target: PropTypes.object.isRequired,
  detailsExpanded: PropTypes.bool.isRequired,
  onDetailsToggle: PropTypes.func.isRequired,
  trackingAttrs: PropTypes.object.isRequired,
};
